import type { FC, PropsWithChildren } from "react";
import type { AuthFailureReport } from "../hooks/use-auth-context";
import { AuthContextProvider } from "../hooks/use-auth-context";

export interface AuthProviderProps {
  authClientId: string;
  /**
   * Optional so app wiring can trail the library — the five surfaces do not deploy together
   * (`libraries/**` ships a new agency image; the rest go out through Vercel, and panels reaches
   * desktop users only on their next update).
   */
  onAuthFailure?: (failure: AuthFailureReport) => void;
}

export const AuthProvider: FC<PropsWithChildren<AuthProviderProps>> = ({ authClientId, children, onAuthFailure }) => {
  if (!authClientId || authClientId === "undefined") {
    throw new Error("React App Auth Client Id is not set.");
  }

  return (
    <AuthContextProvider authClientId={authClientId} onAuthFailure={onAuthFailure}>
      {children}
    </AuthContextProvider>
  );
};
